import React from "react";
import "./SectionHeading.scss";

export default function SectionHeading({ children }) {
  return (
    <h2 className="text-3xl md:text-3xl lg:text-3xl font-medium	 text-center">
      {children}
    </h2>
  );
}
